<template>
    <v-card>
        <v-card-title outlined class="text-center text-wrap">
            {{ parseDate() }}
        </v-card-title>
    </v-card>
</template>

<script>
export default {
    name: 'DateDisplayCard',
    props: {
        date: {
            type: Date, 
            required: true,
        }
    },
    methods: {
        parseMonth: val => {
        if (Number.isInteger(val)){
            const months = [
            "January", "February", "March", "April", "May", 
            "June", "July", "August", "September", "October", 
            "November", "December"];

            return months[val];
        }
    }, 
    parseDate(){
        const date = this.date
        const day = date.getDate() 
        const month = date.getMonth()
        const year = date.getFullYear()
        return `${this.parseMonth(month)} ${day}, ${year}`
    }
  },
}

</script>